module.exports = __webpack_public_path__ + "static/media/Instant_Visio_Keynote.e243b3bd.pdf";